import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {SidebarComponent} from "./sidebar.component";
import {TooltipModule} from "primeng/tooltip";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule
  ],
  declarations: [SidebarComponent],
  exports: [SidebarComponent],
})
export class SideNavigationBarModule {
}
